export default __webpack_public_path__ + "9a49b8c.png";